import { FC } from 'react'
import { useTimelineTickPositions } from './hooks/useTimelineTickPositions'
import { TimelineTick } from './TimelineTick'

interface Props {
  containerRect: DOMRect
}

export const TimelineTicks: FC<Props> = ({ containerRect }) => {
  const positions = useTimelineTickPositions(containerRect.width)

  return (
    <>
      {positions.map((position) => (
        <TimelineTick position={position} key={position} />
      ))}
    </>
  )
}
